import { StytchProvider } from '@stytch/nextjs';
import { useAuth } from '@chordcommerce/gatsby-theme-autonomy';

const AuthProvider = ({ children }) => {
  const { client } = useAuth();
  return <StytchProvider stytch={client}>{children}</StytchProvider>;
};

export default AuthProvider;
